// extracted by mini-css-extract-plugin
var _1 = "styles-module__algoliaSearchBox___Ir091";
var _2 = "styles-module__birthdayContainer___oVNpN";
var _3 = "styles-module__birthdayLabel___N6LTC";
var _4 = "styles-module__calorieContainer___tFs4I";
var _5 = "styles-module__calorieSection___yDDV8";
var _6 = "styles-module__flexRow___uFYUv";
var _7 = "styles-module__phoneInput___ILyCi";
export { _1 as "algoliaSearchBox", _2 as "birthdayContainer", _3 as "birthdayLabel", _4 as "calorieContainer", _5 as "calorieSection", _6 as "flexRow", _7 as "phoneInput" }
